import { HttpHandlerFn, HttpRequest } from '@angular/common/http';

/** Pass untouched request through to the next request handler. */
export const headerInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (req.method === 'GET') {
    const customRequest = req.clone({
      headers: req.headers.set('Cache-Control', 'no-cache').set('Pragma', 'no-cache')
    });

    return next(customRequest);
  }

  return next(req);
};
